import type {SavedView} from '../../types'

/**
 * Given the list of saved views before deletion and the id being deleted,
 * returns the id of the row whose title link should receive focus once the
 * DOM settles, or `'heading'` to fall back to the page's `<h1>` when the
 * list becomes empty.
 */
export function pickPostDeleteFocusTargetId(
  views: readonly SavedView[],
  deletedId: SavedView['id'],
): SavedView['id'] | 'heading' | null {
  const idx = views.findIndex(v => v.id === deletedId)
  if (idx === -1) return null
  return views[idx + 1]?.id ?? views[idx - 1]?.id ?? 'heading'
}
